export default __webpack_public_path__ + "static/media/docs-cortisol-chart.ca00c4b9.jpg";